class AltNav extends HTMLElement {
  constructor() {
    super()

    document.body.addEventListener("wheel", this.checkScrollDirection.bind(this))
  }

  checkScrollDirection(event) {
    function checkScrollDirectionIsUp() {

      if (event.wheelDelta) {
        return event.wheelDelta > 0 || window.pageYOffset === 0
      }

      return event.deltaY < 0 || window.pageYOffset === 0
    }

    checkScrollDirectionIsUp()
      ? this.classList.remove("scrolled_down")
      : this.classList.add("scrolled_down")
  }
}

customElements.define("alt-nav", AltNav)